var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.edit)?[_c('h4',[_vm._v(_vm._s(_vm.item.name))]),_c('input',{staticClass:"uk-input",attrs:{"type":"text","name":_vm.item.key},domProps:{"value":_vm.info}})]:[_c('h4',[_vm._v(_vm._s(_vm.item.name))]),_c('p',[_vm._v(_vm._s(_vm.info))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }